import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Swal from 'sweetalert2'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'

interface Warehouse {
    idWarehouses: any; // Use a more specific type if you have one
    name: string;
    address: string;
    details: string;
    idProjects: any;
    storeManagers?: any[];
}

const initialForm: Warehouse = {
    idWarehouses: null,
    name: '',
    address: '',
    details: '',
    idProjects: '',
    storeManagers: [],
};

export default function WarehouseList() {
    const [newData, setNewData] = useState({});
    const [form, setForm] = useState<Warehouse>(initialForm);
    const [editIndex, setEditIndex] = useState<number | null>(null);

    const [projects, setProjects] = useState<any[]>([]);
    const [project, setProject] = useState<any>({ label: 'Select Project', value: '' });

    const [storeManagers, setStoreManagers] = useState<any[]>([]);
    const [selectedStoreManagers, setSelectedStoreManagers] = useState<any[]>([]);

    useEffect(() => {
        getProjects();
    }, []);

    useEffect(() => {
      if (form.idProjects) {
        getStoreManagers(form.idProjects);
      } else {
        setStoreManagers([]);
        setSelectedStoreManagers([]);
      }
    }, [form.idProjects]);

    const getStoreManagers = (projectId: any) => {
      fetch(`${process.env.REACT_APP_API_URL}store-manager/users?idProjects=${projectId}`, getRequestOptions())
        .then((resp) => resp.json())
        .then((resp) => {
          let managerObj = resp?.data?.map((item: any) => ({
            label: item.name,
            value: item.id
          }));
          setStoreManagers(managerObj);
        })
        .catch((error) => {
          console.log(error, 'fetch store managers error');
        });
    };

    const createWarehouse = (data: Warehouse) => {
      fetch(process.env.REACT_APP_API_URL + 'warehouse', {
        ...postRequestOptions(),
        body: JSON.stringify(data),
      })
        .then((resp) => resp.json())
        .then(() => {
          setNewData({ id: Date.now() });
        })
        .catch((error) => {
          console.log(error, 'create warehouse error');
        });
    };

    const updateWarehouse = (data: Warehouse, id: any) => {
      fetch(process.env.REACT_APP_API_URL + 'warehouse/' + id, {
        ...postRequestOptions(),
        method: 'PUT',
        body: JSON.stringify(data),
      })
        .then((resp) => resp.json())
        .then(() => {
          setNewData({ id: Date.now() });
        })
        .catch((error) => {
          console.log(error, 'update warehouse error');
        });
    };

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
                if (projectObj.length > 0) {
                    setProject(projectObj[0]);
                    setForm((prev) => ({ ...prev, idProjects: projectObj[0].value }));
                }
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleProjectChange = (project: any) => {
        setProject(project);
        setForm({ ...form, idProjects: project.value });
        setSelectedStoreManagers([]);
    }

  const handleStoreManagersChange = (selected: any) => {
    setSelectedStoreManagers(selected);
    setForm({ ...form, storeManagers: selected ? selected.map((m: any) => m.value) : [] });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name || !form.idProjects) return;
    const submitData = {
      ...form,
      storeManagers: selectedStoreManagers ? selectedStoreManagers.map((m: any) => m.value) : [],
    };
    if (editIndex !== null) {
      updateWarehouse(submitData, form.idWarehouses || editIndex);
      setEditIndex(null);
    } else {
      createWarehouse(submitData);
    }
    setForm(initialForm);
    setSelectedStoreManagers([]);
  };

  const handleEdit = (warehouse: any) => {
    // Find warehouse by id, not by index, for DataTable compatibility
    if (warehouse) {
      setForm({
        ...warehouse,
        storeManagers: warehouse.users ? warehouse.users.map((m: any) => m.id) : []
      });
      setEditIndex(warehouse.idWarehouses || warehouse.id);
      setProject({ label: warehouse.projectName, value: warehouse.idProjects });
      setSelectedStoreManagers(warehouse.users ? warehouse.users.map((m: any) => ({ label: m.name, value: m.id })) : []);
    }
  };

  const deleteWarehouse = async (id: number): void => {
          const confirm = await Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this Warehouse?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#ec008c',
              cancelButtonText: 'Cancel',
              confirmButtonText: 'Yes, Delete it!',
          })
          if (confirm.value) {
              const myToken: string | null = localStorage.getItem('MyToken');
              let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
              fetch(`${process.env.REACT_APP_API_URL}warehouse/${id}`, {
                  method: 'DELETE',
                  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
              })
              .then((resp: Response) => {
                  return resp.json();
              })
              .then((resp: any) => {
                  if (resp.success) {
                      const successMsg: string = resp.successMessage;
                      Swal.fire({
                          icon: 'success',
                          title: 'Deleted!',
                          text: successMsg,
                      });
                      setNewData({ id: Date.now() });
                  }else{
                      const errorMsg: string = resp.errorMessage;
                      Swal.fire({
                          icon: 'error',
                          title: 'Delete Failed!',
                          text: errorMsg,
                      });
                  }
              })
              .catch((error: any) => {
                  Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Vendor not found!',
                  });
                  console.error('Error:', error);
              });
          }
          
      };


  const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project Name', style: { textAlign: 'left' } },
        { value: 'name', title: 'Name', style: { textAlign: 'left' } },
        { value: 'address', title: 'Address', style: { textAlign: 'left' } },
        { value: 'details', title: 'Details', style: { textAlign: 'left' } },
        {
            value: 'users',
            title: 'Assigned Users',
            style: { textAlign: 'left' },
            hasActionsComponent: true,
            actionsComponent: (row: any) => (
                <>
                    {Array.isArray(row.users) && row.users.length > 0 ? (
                        row.users.map((user: any, idx: number) => (
                            <span key={user.id} className="badge bg-info me-2">
                                {typeof user === 'object' && user !== null && 'name' in user ? user.name : JSON.stringify(user)}
                                {idx < row.users.length - 1 ? '' : ''}
                            </span>
                        ))
                    ) : (
                        <span className="text-muted">No users</span>
                    )}
                </>
            )
        },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button className="btn btn-light-primary btn-sm" onClick={() => handleEdit(row)}>
                            <KTSVG
                                path='/media/svg/icons/Communication/Write.svg'
                                className='svg-icon-5 svg-icon'
                            />		Edit
                        </button>
                        <button className="btn btn-light-danger btn-sm ms-2" onClick={() => deleteWarehouse(row.idWarehouses || row.id)}>
                            <KTSVG
                                path='/media/svg/icons/General/Trash.svg'
                                className='svg-icon-5 svg-icon'
                            />		Delete
                        </button>
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        name: {
            filterType: 'like',
            filterValue: '',
        },
        address: {
            filterType: 'like',
            filterValue: '',
        },
        details: {
            filterType: 'like',
            filterValue: '',
        },
        users: {
            filterType: 'like',
            filterValue: '',
        }
    }

    const url = process.env.REACT_APP_API_URL + 'warehouse/dt'
    
  return (
    <div className="container py-10">
      <div className="card card-bordered shadow-sm">
        <div className="card-header bg-light">
          <h3 className="card-title fw-bold">Create / Edit Warehouse</h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row mb-4">
              <div className="col-md-4 mb-3">
                <label htmlFor="idProjects" className="form-label">Select Project <span className="required text-danger"></span></label>
                <Select
                    value={project}
                    onChange={handleProjectChange}
                    options={projects}
                    menuPosition="fixed"
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label required">Warehouse Name</label>
                <input name="name" value={form.name} onChange={handleChange} required className="form-control" />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Store Managers</label>
                <Select
                  isMulti
                  value={selectedStoreManagers}
                  onChange={handleStoreManagersChange}
                  options={storeManagers}
                  menuPosition="fixed"
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  placeholder="Select Store Managers"
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-6 mb-3">
                <label className="form-label required">Warehouse Address</label>
                <textarea name="address" value={form.address} onChange={handleChange} required className="form-control" />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Warehouse Details</label>
                <textarea name="details" value={form.details} onChange={handleChange} className="form-control" />
              </div>
            </div>
            
            <div className="d-flex gap-2">
              <button type="submit" className="btn btn-primary px-5">{editIndex !== null ? 'Update' : 'Save'}</button>
              {editIndex !== null && (
                <button type="button" className="btn btn-light" onClick={() => { setForm(initialForm); setEditIndex(null); }}>Cancel</button>
              )}
            </div>
            {/* <pre className="mt-3">{JSON.stringify(form, null, 2)}</pre> */}
          </form>
        </div>
      </div>
      <div className="card card-bordered shadow-sm mt-10">
        <div className="card-header bg-light">
          <h3 className="card-title fw-bold">Warehouses</h3>
        </div>
        <div className="card-body p-4">
            <DataTable url={url} columns={columns} filters={filters} newData={newData} />
        </div>
      </div>
    </div>
  );
}
